import { EMPTY } from "../../Constants";

const initialState = {
  activePolygon: null,
  google: {},
  fieldMap: {},
  wellCoordinates: {},
  isWellShown: false,
  fieldData: EMPTY,
  farmName: EMPTY,
  wellGPM: EMPTY,
  isFieldAdded: false,
  fieldName: EMPTY,
  addedFields: [],
  farms: [],
  business: [],
  surfaceWaterPercentage: EMPTY,
  groundWaterPercentage: EMPTY,
  selectedFieldAdded: null,
  allPolygons: {},
  isGeoJsonPolygonFetched: false,
  form_display: EMPTY,
  crops: [],
  tillages: [],
  userCropDetails: [],
  userRegisteredFields: null,
};

const getFarmerDetails = (state = initialState, action) => {
  let newAddedFields = [];
  let wells = [];

  switch (action.type) {
    case "ACTIVE_POLYGON":
      const result = Object.assign({}, state, {
        fieldMap: action.val1,
        google: action.val2,
      });
      return result;
    case "ALL_GEOJSON_POLYGON":
      return {
        ...state,
        allPolygons: action.allGeoJson,
      };
    case "ALL_REGISTERED_FIELDS":
      return {
        ...state,
        userRegisteredFields: action.allUserRegisteredFields,
      };
    case "ENTITIES":
      return {
        ...state,
        crops: action.CropArray,
        tillages: action.TillageArray,
      };
    case "IS_GEOJSON_POLYGON_FETCHED":
      return {
        ...state,
        isGeoJsonPolygonFetched: action.isGeoJsonFetched,
      };
    case "FORM_TYPE":
      return {
        ...state,
        form_display: action.formDisplay,
      };
    case "SET_USER_CROP_DETAILS":
      return {
        ...state,
        userCropDetails: action.cropsDetails,
      };
    case "SET_INITIAL_FARMS":
      return {
        ...state,
        farms: action.farms,
      };
    case "SET_INITIAL_BUSINESS":
      return {
        ...state,
        business: action.business,
      };
    case "RESET_STATE":
      return {
        ...state,
        ...initialState,
      };
    case "SELECT_POLYGON":
      return {
        ...state,
        activePolygon:
          action.activePolygon !== null ? action.activePolygon : null,
      };

    case "FIELD_ADDED":
      return {
        ...state,
        selectedFieldAdded:
          action.fieldAdded !== null ? action.fieldAdded : null,
      };

    case "SHOW_FIELD_WELL":
      const result2 = Object.assign({}, state, {
        wellCoordinates: action.wellCoordinates,
        isWellShown: action.isWellShown,
      });
      return result2;

    case "SET_FARM_BUSINESS":
      const result4 = Object.assign({}, state, {
        farms: action.farms,
        business: action.business,
      });
      return result4;

    case "SAVE_FIELD_POPUP_DATA":
      const activePolygon = state.activePolygon;
      for (let well in action.well_details) {
        wells.push({
          id: action.well_details[well].id,
          well_id: action.well_details[well].well_id,
          gpm: action.well_details[well].gpm,
          ugpm:
            action.well_details[well].ugpm.toString().trim() === EMPTY
              ? action.well_details[well].gpm
              : action.well_details[well].ugpm,
          active: action.well_details[well].activeWell,
          isElectricWell: action.well_details[well].isElectricWell,
        });
      }
      newAddedFields.push({
        fieldName: action.fieldName,
        farmName: action.farmName,
        businessName: action.businessName,
        surfaceWaterIrrigation: action.surfaceWaterIrrigation,
        wells: wells,
        irrig_unit_Id: action.irrig_unit_id,
        irrigUnit: activePolygon,
        surfaceWaterPercentage: action.surfaceWaterPercentage,
        groundWaterPercentage: action.groundWaterPercentage,
      });
      return {
        ...state,
        addedFields: state.addedFields.concat(newAddedFields),
        farms: action.farms,
        business: action.business,
      };
    case "UPDATE_FIELD_POPUP_DATA":
      newAddedFields = [];
      wells = [];
      for (let well in action.well_details) {
        wells.push({
          id: action.well_details[well].id,
          well_id: action.well_details[well].well_id,
          gpm: action.well_details[well].gpm,
          ugpm:
            action.well_details[well].ugpm.toString().trim() === EMPTY
              ? action.well_details[well].gpm
              : action.well_details[well].ugpm,
          active: action.well_details[well].activeWell,
          isElectricWell: action.well_details[well].isElectricWell,
        });
      }
      const filteredFields = state.addedFields.filter(
        (item) => item !== state.addedFields[action.index]
      );
      const irrigUnit = state.addedFields.filter(
        (item) => item === state.addedFields[action.index]
      );

      newAddedFields.push({
        fieldName: action.fieldName,
        farmName: action.farmName,
        businessName: action.businessName,
        surfaceWaterIrrigation: action.surfaceWaterIrrigation,
        wells: wells,
        irrig_unit_Id: action.irrig_unit_id,
        irrigUnit: irrigUnit[0].irrigUnit,
        surfaceWaterPercentage: action.surfaceWaterPercentage,
        groundWaterPercentage: action.groundWaterPercentage,
      });

      return {
        ...state,
        addedFields: filteredFields.concat(newAddedFields),
        farms: action.farms,
        business: action.business,
      };

    case "REMOVE_SELECTED_FIELD":
      return {
        ...state,
        addedFields: state.addedFields.filter(
          (item) => item !== state.addedFields[action.index]
        ),
      };
    case "CLEAR_SELECTED_FIELD":
      return {
        ...state,
        addedFields: [],
      };
    default:
      return state;
  }
};

export default getFarmerDetails;
